import BedOccupancyHistogram from './Component';

export default BedOccupancyHistogram;
